import { render, staticRenderFns } from "./merchant_info.vue?vue&type=template&id=1f38a6f7&scoped=true&"
import script from "./merchant_info.vue?vue&type=script&lang=js&"
export * from "./merchant_info.vue?vue&type=script&lang=js&"
import style0 from "./merchant_info.vue?vue&type=style&index=0&id=1f38a6f7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f38a6f7",
  null
  
)

export default component.exports